import script from "./UiTableVehicleMessagesTd.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTableVehicleMessagesTd.vue?vue&type=script&setup=true&lang=js"

import "./UiTableVehicleMessagesTd.vue?vue&type=style&index=0&id=6f9653a9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9653a9"]])

export default __exports__